import {createSlice} from "@reduxjs/toolkit";

const initialProvinceState = {
    listLoading: false,
    actionsLoading: false,
    provinces: [],
    error: null
  };

  export const callTypes = {
    list: "list",
    action: "action"
  };
  

const agencySlice = createSlice({
  name: 'province',
  initialState:initialProvinceState,
  reducers: {
      catchError: (state, action) => {
        state.error = `${action.type}: ${action.payload.error}`;
        if (action.payload.callType === callTypes.list) {
          state.listLoading = false;
        } else {
          state.actionsLoading = false;
        }
      },
      startCall: (state, action) => {
        state.error = null;
        if (action.payload.callType === callTypes.list) {
          state.listLoading = true;
        } else {
          state.actionsLoading = true;
        }
      },
      provincesFetched: (state, action) => {
        const { entities } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.provinces = entities;
      }
    }
});

export const {actions} = agencySlice;
export const {reducer} = agencySlice;